import { TagProps } from '@conexasaude/conexa-hero'
import { Status } from '@/modules/Users/services/mapper/GetAuthorizationData/GetAuthorizationData.types'
import { AuthorizationField } from './AuthorizationData.types'
import { format } from 'date-fns'

export const statusMapping: Record<
  Status,
  { tagVariant: TagProps['variant']; label: string }
> = {
  AUTORIZADO: { tagVariant: 'success', label: 'Autorizado' },
  NEGADO: { tagVariant: 'error', label: 'Negado' },
  EM_ANALISE: { tagVariant: 'warning', label: 'Em Análise' },
  SOLICITACAO_CANCELADA: {
    tagVariant: 'error',
    label: 'Solicitação Cancelada',
  },
}

export const fields: AuthorizationField[] = [
  { label: 'Mensagem da glosa', value: data => data?.messageGloss ?? '-' },
  { label: 'ID Autorizador', value: (_, idAuthorizer) => idAuthorizer ?? '-' },
  { label: 'Token da solicitação', value: data => data?.token ?? '-' },
  {
    label: 'Data solicitação',
    value: data => data?.formattedRequestDateTime,
  },
  {
    label: 'Nº guia prestador',
    value: data => data?.authorizationData?.providerGuideNumber ?? '-',
  },
  {
    label: 'Nº guia operadora',
    value: data => data?.authorizationData?.operatorGuideNumber ?? '-',
  },
  {
    label: 'Quantidade solicitada',
    value: data => data?.authorizationData?.requestedQuantity ?? '-',
  },
  {
    label: 'Quantidade autorizada',
    value: data => data?.authorizationData?.authorizedQuantity ?? '-',
  },
  {
    label: 'Código do procedimento',
    value: data => data?.authorizationData?.procedureCode ?? '-',
  },
  {
    label: 'Descrição do procedimento',
    value: data => data?.authorizationData?.procedureDescription ?? '-',
  },
  {
    label: 'Carteirinha',
    value: data => data?.authorizationData?.cardNumber ?? '-',
  },
  { label: 'Registro ANS', value: data => data?.ansRecord ?? '-' },
  { label: 'CID', value: data => data?.cid ?? '-' },
  {
    label: 'Status de execução de guia',
    value: data => (data?.isExecuted ? 'Executado' : 'Não executado'),
  },

  {
    label: 'Saldo do pacote',
    value: data => {
      const used = data?.authorizationData?.usedQuantity
      const qtdAuthorized = data?.authorizationData?.authorizedQuantity

      if (used === undefined || qtdAuthorized === undefined) {
        return '-'
      }

      if (used === 1 && qtdAuthorized === 1) {
        return '-'
      }

      return qtdAuthorized - used
    },
  },
]
